export default function Footer() {
  return (
    <footer className="relative bg-black py-16 md:py-20 border-t border-white/10">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <h3 className="text-white font-bold text-lg md:text-xl tracking-wide uppercase mb-2">
              SİLİVRİ OTO YEDEK PARÇA
            </h3>
            <p className="text-brand-muted text-sm md:text-base">
              Orijinal oto yedek parça, akü ve yol yardım çözümleri.
            </p>
          </div>
          <div className="text-brand-muted text-sm md:text-right">
            <p>İstanbul / Silivri</p>
            <p className="mt-1">2026 Silivri Oto Yedek Parça</p>
          </div>
        </div>
      </div>
    </footer>
  );
}